(function() {
  function toArray(elements) {
    var result = [];
    var i;
    if (!elements) {
      return result;
    }
    for (i = 0; i < elements.length; i += 1) {
      result.push(elements[i]);
    }
    return result;
  }

  function trimText(value) {
    return (value || '').replace(/^\s+|\s+$/g, '');
  }

  function normalizeText(value) {
    return trimText((value || '').toLowerCase().replace(/\s+/g, ' '));
  }

  function hasClass(element, className) {
    if (!element || !className) {
      return false;
    }
    return (
      (' ' + element.className + ' ').indexOf(' ' + className + ' ') !== -1
    );
  }

  function closestByClass(node, className) {
    while (node) {
      if (hasClass(node, className)) {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  function queryTerms(value) {
    var normalized = normalizeText(value);
    if (normalized.replace(/\s/g, '').length < 3) {
      return [];
    }
    return normalized.split(' ');
  }

  function elementText(element) {
    var clone = element.cloneNode(true);
    var editButtons = toArray(clone.getElementsByClassName('tileEditButtons'));
    var i;

    for (i = 0; i < editButtons.length; i += 1) {
      if (editButtons[i].parentNode) {
        editButtons[i].parentNode.removeChild(editButtons[i]);
      }
    }
    return normalizeText(clone.textContent || clone.innerText || '');
  }

  function matchesTerms(element, terms) {
    var text = elementText(element);
    var i;

    for (i = 0; i < terms.length; i += 1) {
      if (text.indexOf(terms[i]) === -1) {
        return false;
      }
    }
    return true;
  }

  function moveToContentCore(root) {
    var contentCore = document.getElementById('content-core');
    var tileWrapper = closestByClass(root, 'tileWrapper');
    var nodeToMove = tileWrapper || root;

    if (!contentCore) {
      return;
    }

    if (
      nodeToMove.parentNode !== contentCore ||
      contentCore.firstChild !== nodeToMove
    ) {
      contentCore.insertBefore(nodeToMove, contentCore.firstChild);
    }
  }

  function initTileFilter(root) {
    var form;
    var input;
    var targetClass;
    var canModify;
    var isEditing;

    if (root.getAttribute('data-tile-filter-ready') === 'true') {
      return;
    }

    form = root.querySelector('.tile-filter-form');
    input = root.querySelector('.tile-filter-input');
    targetClass = root.getAttribute('data-filter-class');

    if (!form || !input || !targetClass) {
      return;
    }

    root.setAttribute('data-tile-filter-ready', 'true');

    canModify = root.getAttribute('data-can-modify') === 'true';
    isEditing =
      document.body && document.body.className
        ? (' ' + document.body.className + ' ').indexOf(' template-edit ') !==
          -1
        : false;

    if (!canModify || !isEditing) {
      moveToContentCore(root);
    }

    function applyFilter() {
      var terms = queryTerms(input.value);
      var elements = toArray(document.getElementsByClassName(targetClass));
      var i;
      var element;

      for (i = 0; i < elements.length; i += 1) {
        element = elements[i];
        if (element.contains(root) || root.contains(element) || !terms.length) {
          element.style.display = '';
          continue;
        }
        element.style.display = matchesTerms(element, terms) ? '' : 'none';
      }
    }

    form.addEventListener('submit', function(event) {
      event.preventDefault();
    });

    input.addEventListener('input', applyFilter);
    input.addEventListener('keyup', applyFilter);

    toArray(root.getElementsByClassName('tile-filter-submit')).forEach(function(
      button
    ) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        input.value = '';
        applyFilter();
      });
    });

    applyFilter();
  }

  function initTileFilters() {
    var filters = toArray(document.getElementsByClassName('tile-filter'));
    var i;

    for (i = 0; i < filters.length; i += 1) {
      initTileFilter(filters[i]);
    }
  }

  window.initTileFilters = initTileFilters;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTileFilters);
  } else {
    initTileFilters();
  }
  window.setTimeout(initTileFilters, 250);
  window.setTimeout(initTileFilters, 1000);
  window.setTimeout(initTileFilters, 2000);
  window.setTimeout(initTileFilters, 5000);
  window.addEventListener('load', initTileFilters, false);
  document.addEventListener('rtTilesLoaded', initTileFilters, true);
})();
